import { useQueryClient } from "@tanstack/react-query";
import { cmsServices } from "features/cms/services/cms.service";

export const usePrefetchCms = () => {
  const queryClient = useQueryClient();

  const prefetchCmsPages = (params) => {
    queryClient.prefetchQuery({
      queryKey: ["cmsPages", params],
      queryFn: () => cmsServices.getCmsPages(params),
      staleTime: 5 * 60 * 1000,
    });
  };

  const prefetchNextPage = (currentParams, totalPages) => {
    const currentPage = parseInt(currentParams.page);
    if (currentPage < totalPages) {
      prefetchCmsPages({ ...currentParams, page: String(currentPage + 1) });
    }
  };

  const prefetchPrevPage = (currentParams) => {
    const currentPage = parseInt(currentParams.page);
    if (currentPage > 1) {
      prefetchCmsPages({ ...currentParams, page: String(currentPage - 1) });
    }
  };

  return {
    prefetchCmsPages,
    prefetchNextPage,
    prefetchPrevPage,
  };
}